export const langFriends = {
    "arm": {
        tr_friends: "Ընկերներ",
        tr_find: "Գտնել",
        tr_requests: "Հայտեր",
        tr_sent: "Ուղարկված",
        tr_searchPlaceholder: "Էլ․ հասցե, հեռախոսահամար կամ մականուն",
        tr_searchHint: "Մուտքագրեք ամբողջական էլ․ հասցեն, հեռախոսահամարը կամ մականունը",
        tr_noResults: "Ոչինչ չի գտնվել",
        tr_addFriend: "Ավելացնել",
        tr_requestSent: "Հայտն ուղարկված է",
        tr_alreadyFriends: "Ընկերներ եք",
        tr_accept: "Ընդունել",
        tr_decline: "Մերժել",
        tr_cancel: "Չեղարկել",
        tr_remove: "Հեռացնել",
        tr_noRequests: "Հայտեր չկան",
        tr_noFriends: "Դեռ ընկերներ չունեք",
        tr_close: "Փակել",
        tr_newRequest: "Նոր ընկերության հայտ",
        tr_confirmRemove: "Հեռացնե՞լ ընկերների ցուցակից",
    },
    "eng": {
        tr_friends: "Friends",
        tr_find: "Find",
        tr_requests: "Requests",
        tr_sent: "Sent",
        tr_searchPlaceholder: "Email, phone number or nickname",
        tr_searchHint: "Enter the full email, phone number or nickname",
        tr_noResults: "Nobody found",
        tr_addFriend: "Add friend",
        tr_requestSent: "Request sent",
        tr_alreadyFriends: "Friends",
        tr_accept: "Accept",
        tr_decline: "Decline",
        tr_cancel: "Cancel",
        tr_remove: "Remove",
        tr_noRequests: "No requests",
        tr_noFriends: "You have no friends yet",
        tr_close: "Close",
        tr_newRequest: "New friend request",
        tr_confirmRemove: "Remove from friends?",
    },
    "fr": {
        tr_friends: "Amis",
        tr_find: "Rechercher",
        tr_requests: "Demandes",
        tr_sent: "Envoyées",
        tr_searchPlaceholder: "E-mail, téléphone ou pseudo",
        tr_searchHint: "Saisissez l'e-mail, le numéro de téléphone ou le pseudo complet",
        tr_noResults: "Personne n'a été trouvé",
        tr_addFriend: "Ajouter",
        tr_requestSent: "Demande envoyée",
        tr_alreadyFriends: "Amis",
        tr_accept: "Accepter",
        tr_decline: "Refuser",
        tr_cancel: "Annuler",
        tr_remove: "Retirer",
        tr_noRequests: "Aucune demande",
        tr_noFriends: "Vous n'avez pas encore d'amis",
        tr_close: "Fermer",
        tr_newRequest: "Nouvelle demande d'ami",
        tr_confirmRemove: "Retirer de vos amis ?",
    },
    "arb": {
        tr_friends: "الأصدقاء",
        tr_find: "بحث",
        tr_requests: "الطلبات",
        tr_sent: "المرسلة",
        tr_searchPlaceholder: "البريد الإلكتروني أو رقم الهاتف أو الاسم المستعار",
        tr_searchHint: "أدخل البريد الإلكتروني أو رقم الهاتف أو الاسم المستعار كاملاً",
        tr_noResults: "لم يتم العثور على أحد",
        tr_addFriend: "إضافة صديق",
        tr_requestSent: "تم إرسال الطلب",
        tr_alreadyFriends: "أصدقاء",
        tr_accept: "قبول",
        tr_decline: "رفض",
        tr_cancel: "إلغاء",
        tr_remove: "إزالة",
        tr_noRequests: "لا توجد طلبات",
        tr_noFriends: "ليس لديك أصدقاء بعد",
        tr_close: "إغلاق",
        tr_newRequest: "طلب صداقة جديد",
        tr_confirmRemove: "إزالة من الأصدقاء؟",
    },
    "rus": {
        tr_friends: "Друзья",
        tr_find: "Найти",
        tr_requests: "Запросы",
        tr_sent: "Отправленные",
        tr_searchPlaceholder: "Эл. почта, номер телефона или никнейм",
        tr_searchHint: "Введите полный адрес эл. почты, номер телефона или никнейм",
        tr_noResults: "Никто не найден",
        tr_addFriend: "Добавить в друзья",
        tr_requestSent: "Запрос отправлен",
        tr_alreadyFriends: "Друзья",
        tr_accept: "Принять",
        tr_decline: "Отклонить",
        tr_cancel: "Отменить",
        tr_remove: "Удалить",
        tr_noRequests: "Нет запросов",
        tr_noFriends: "У вас пока нет друзей",
        tr_close: "Закрыть",
        tr_newRequest: "Новый запрос в друзья",
        tr_confirmRemove: "Удалить из друзей?",
    }
}
